import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { ThemeApiStructure } from "@interfaces/theme";

export const interfaceConfig: InterfaceConfig = {
  name: "providencia",
  interest_rate: 30,
  companyNames: ["Lendit Group SAPI de CV"],
  home_url: "",
  metadata: {
    title: "",
    description: "",
    favicon: "",
    keywords: undefined,
    ogImage: undefined,
  },
};

export const localTheme: ThemeApiStructure = {
  id:
    import.meta.env.VITE_ENV === "PROD"
      ? "49f931c1-d705-4b02-a710-a5da2e0fdec1"
      : "49f931c1-d705-4b02-a710-a5da2e0fdec1",
  name: "providencia",
  display_name: "Providencia",
  description: "",
  code: "",
  url_site: "/solicita_tu_credito",
  url_privacy_notice: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  url_terms_and_conditions: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  palette: {
    palette: {
      primary: {
        base: "#E5E5E5",
        dark: "#2F3031", // obscuro
        main: "#47AA42", // color 2
        light: "#4D4D4D", // color 1
        accent: "#6D6E71", // accents
      },
      components: {},
    },
    interface: {
      navbar: {
        logo: "providencia/portal/logos/logo.png",
        logo_width: 142,
        logo_height: "auto",
      },
      lateral: {
        bg_dark: "#2F3031",
        bg_light: "#6D6E71",
        logo_bg_dark: "providencia/portal/logos/logo_dark_bg.png",
        text_bg_dark: "#FFFFFF",
        logo_bg_light: "providencia/portal/logos/logo_dark_bg.png",
        text_bg_light: "#FFFFFF",
        logo_width: 250,
        logo_height: "auto",
      },
      metadata: {
        title: "Providencia",
        favicon: "providencia/portal/logos/favicon.ico",
        // description:
        //   "Somos una Sociedad Financiera de Objeto Múltiple que ofrece financiamiento al sector agropecuario en el Norte del País.",
      },
    },
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_xNemClkcb",
      userPoolClientId: "43gc1fvrdk55b6j4g5nq6k21vo",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_FhHFierzr",
      userPoolClientId: "5qvl9t4n2qtvg99rv30t6gqqum",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
